<template>
    <div>
        <div class="options d-flex align-items-center m-3 justify-content-between">
            <div class="d-flex align-items-center col-sm-6 pl-0">
                <div class="d-flex w-100">
                    <input class="glued-right bg-lighter w-100" type="text" v-model="searchQuery" placeholder="Search">
                    <div class="glued-left dark"><i class="ico-search larger color-1"></i></div>
                </div>
				<div class="d-flex m-3 align-items-center w-100 ml-3">
					<span class="fs-small bold mr-2">Show inactive services</span>
					<toggle-button @change="toggleShowInactive" v-model="showInactive" :labels="{checked: 'Yes', unchecked: 'No'}" />
				</div>
            </div>

            <button class="btn" @click="addService">
                <i class="ico ico-add mt-1"></i> Add Service
            </button>
        </div>

        <div v-if="getLoadingExtras" class="p-4 text-center">
            <loader></loader>
        </div>
        <div v-else>
            <list :header="header" :body="body" :rows="filteredResults" :actions="actions"></list>
        </div>
    </div>
</template>

<script>
    import { mapGetters, mapActions } from 'vuex'
    import List from '@/tools/list/baseList'
    import Search from '@/tools/Search'
    import Export from '@/tools/Export'
    import Loader from '@/tools/loaders/loader1'

    export default {
        data() {
            return {
                searchQuery: null,
                body: {
                    selection: {
                        active: false,
                        event: (event) => {}
                    },
                    customCells: {
                        name: this.formatName,
                        priceTotal: this.formatPriceRange,
                        isActive: this.formatIsActive,
                    },
                    customRowClass: this.isValidService,
                    customRowEvent: this.view,
                },
                actions: {
                    label : 'Actions',
                    list: [
                        {
                            slug: 'edit',
                            title: 'Edit',
                            tooltip: 'Edit',
                            params: '',
                            class: '',
                            icon: 'ico-edit largest',
                            event: this.view,
                        },
                        {
                            slug: 'delete',
                            title: 'Delete',
                            tooltip: 'Delete',
                            params: '',
                            class: '',
                            icon: 'ico-delete largest',
                            event: this.remove,
                        }
                    ],
                },
                rowEvent: null,
				showInactive: false
            }
        },
		created(){
			this.showInactive = this.showInactiveExtras;
		},
		props: {
			showInactiveExtras: {
				type: Boolean,
				default: false
			}
		},
        computed: {
            ...mapGetters([
                'getExtras',
                'getExtrasLabels',
                'account',
                'getLoadingExtras',
                'getShowInvoiceOption'
            ]),
            header() {
                const extrasLabel = this.getExtrasLabels;
                const labels = {};

                labels.name = extrasLabel.name;

                if (this.getShowInvoiceOption) {
                    labels.code = extrasLabel.code;
                }

                labels.description = extrasLabel.description;
                labels.priceTotal = extrasLabel.priceTotal;
                labels.isActive = extrasLabel.isActive;

                return {
                    selection: {
                        active: false,
                        event: (event) => {}
                    },
                    list: labels,
                    customClassCell:{
                        code: 'text-nowrap'
                    }
                };
            },
            filteredResults() {
                if (this.searchQuery) {
                    return this.getExtras.filter(extra => {
                        return extra.name.toLowerCase().includes(this.searchQuery.toLowerCase());
                    });
                } else {
                    return this.getExtras;
                }
            },
            namesCount() {
                return this.getExtras.reduce((acc, obj) => {
                    if (obj.name) {
                        acc[obj.name] = (acc[obj.name] || 0) + 1;
                    }
                    return acc;
                }, {});
            }
        },
        methods: {
            ...mapActions([
                'openModal',
                'initExtras',
                'removeItem',
                'setSelectedItem',
                'setSelectedExtra',
            ]),
            isValidService(item) {
                return (this.namesCount[item.name] || 0) > 1 ? 'invalid-group-warning' : '';
            },
			toggleShowInactive() {
				this.$emit('showInactiveExtras', this.showInactive);
			},
            view(item) {
                if (item.id !== undefined) {
                    this.setSelectedExtra(item);
                    this.openModal('ExtraView');
                }
            },
            addService() {
                this.openModal('ExtraAdd');
            },
            remove(item) {
                this.removeItem({
                    table: 'extras',
                    object: 'extra',
                    module: 'inventory',
                    fields: { supplierId: this.account.supplierId, Extra: item }
                });
            },
            formatName(extra) {
                return '<div class="bold">' + extra.name + '</div>';
            },
            formatIsActive(extra) {
                return extra.isActive ? 'Active' : '<div class="color-6">Inactive</div>';
            },
            formatPriceRange(extra) {
                let lowerPrice = extra.prices[0].grossprice;
                let higherPrice = extra.prices[0].grossprice;

                extra.prices.map(price => {
                    higherPrice = (price.grossprice > higherPrice)? price.grossprice : higherPrice;
                    lowerPrice = (price.grossprice < lowerPrice)? price.grossprice : lowerPrice;
                })

                if (lowerPrice == higherPrice) {
                    return higherPrice + '€';
                } else {
                    return lowerPrice + '€ to ' + higherPrice +'€';
                }
            }
        },
        components: {
            List,
            Search,
            Export,
            Loader
        },
    }
</script>

<style lang="scss" scoped>
    .invalid-group-warning {
        background-color: #ffe5e5;
    }
</style>



// WEBPACK FOOTER //
// Extras.vue?45eb566a